import { Injectable } from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import {environment} from '../../../../environments/environment';
import {CookieService} from 'ngx-cookie';
declare var DDP_ENV: any;

@Injectable({
  providedIn: 'root'
})
export class FilterService {
  readonly baseURL = DDP_ENV.webdataUrl;

  constructor(private _http: Http, private cookieService: CookieService) { }

  getAllSystemFilters() {
      console.log('Inside Get All System Filters');
      return this._http.get(this.baseURL + '/filters/campaign?campaign=', this.buildHeaders());
  }

  getFiltersByCampaignId(campaignId) {
      console.log('Inside Get All System Filters');
      return this._http.get(this.baseURL + '/filters/campaign?campaign=' + campaignId, this.buildHeaders());
  }

  getAllCategories() {
      console.log('Inside Get All System Filters');
      return this._http.get(this.baseURL + '/filters/categories', this.buildHeaders());
  }

  getFilterById(filterId) {
      console.log('Inside Get by  Filter Id');
      return this._http.get(this.baseURL + '/filters/' + filterId, this.buildHeaders());
  }

  getFilterByName(filterName) {
      console.log('Inside Get by  Filter Name');
      return this._http.get(this.baseURL + '/filters/name/' + filterName, this.buildHeaders());
  }

  updateFilters(filter) {
      console.log('Inside Update All System Filters');
      return this._http.put(this.baseURL + '/filters', filter, this.buildHeaders());
  }

  saveFilters(filter) {
      console.log('Inside Save All System Filters');
      return this._http.put(this.baseURL + '/filters/all', filter, this.buildHeaders());
  }

    /* Build request header */
    private buildHeaders(): any {
        const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
        return new RequestOptions({ headers: headers });
    }
}
